(function () {
  const regionMappings = {
    Arica: "XV – Región de Arica y Parinacota",
    Tarapacá: "I – Región de Tarapacá",
    Antofagasta: "II – Región de Antofagasta",
    Atacama: "III – Región de Atacama",
    Coquimbo: "IV – Región de Coquimbo",
    Valparaíso: "V – Región de Valparaíso",
    Metropolitana: "RM (XIII) – Región Metropolitana de Santiago",
    "O'Higgins": "VI – Región del Libertador General Bernardo O’Higgins",
    "O’Higgins": "VI – Región del Libertador General Bernardo O’Higgins",
    Maule: "VII – Región del Maule",
    Ñuble: "XVI – Región de Ñuble",
    Biobío: "VIII – Región del Biobío",
    Araucanía: "IX – Región de La Araucanía",
    Ríos: "XIV – Región de Los Ríos",
    Lagos: "X – Región de Los Lagos",
    Aysén: "XI – Región de Aysén del General Carlos Ibáñez del Campo",
    Magallanes: "XII – Región de Magallanes y de la Antártica Chilena",
  };

  function updateRegionOptions(selectElement) {
    // Flag to prevent infinite loop if we observe our own changes, though we only change text
    if (selectElement.dataset.regionsUpdated) return;

    const options = selectElement.options;
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      const text = option.text;

      for (const [key, value] of Object.entries(regionMappings)) {
        // Check if the current option text contains the key (e.g. "Arica")
        // and DOES NOT already match the full value to avoid double replacement
        if (
          text.includes(key) &&
          text !== value &&
          !text.includes("– Región")
        ) {
          option.text = value;
          break;
        }
      }
    }
    selectElement.dataset.regionsUpdated = "true";
  }

  // Observer to watch for the select element being added to the DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Element node
          // Check if the node itself is the select or contains it
          // Selecty often uses a class or ID like 'selecty-region' or inside a container
          // We look for any select that has options resembling regions

          const selects =
            node.tagName === "SELECT"
              ? [node]
              : node.querySelectorAll("select");

          selects.forEach((select) => {
            // Heuristic: check if options contain "Región" or specific keywords if class is unknown
            // Or better, check all selects for region content
            if (
              select.innerHTML.includes("Metropolitana") ||
              select.innerHTML.includes("Valparaíso")
            ) {
              updateRegionOptions(select);
            }
          });
        }
      });
    });
  });

  // Start observing
  document.addEventListener("DOMContentLoaded", () => {
    observer.observe(document.body, { childList: true, subtree: true });

    // Also check initially in case it's already there
    const existingSelects = document.querySelectorAll("select");
    existingSelects.forEach((select) => {
      if (
        select.innerHTML.includes("Metropolitana") ||
        select.innerHTML.includes("Valparaíso")
      ) {
        updateRegionOptions(select);
      }
    });
  });
})();
